<template>
   <uiModal
      @closeModal="activate = false"
      :noHr="true"
      :noCloseBtn="true"
      v-if="activate"
      :notification="true"
   >
      <template slot="body">
         <div class="globalNotifications" ref="notification">
            <div class="header" ref="header" :class="`${type}Header`">
               <img
                  v-if="type === 'success'"
                  src="/clientV2/static/gfx/NewV.svg"
               />
               <img
                  v-if="type === 'error'"
                  src="/clientV2/static/gfx/error.svg"
               />

               <span
                  v-if="type === 'confirm' || type === 'yesno'"
                  class="confirmHeaderText"
                  v-html="text"
               ></span>
            </div>
            <div class="body" ref="body">
               <span v-if="type != 'confirm' && type != 'yesno'">
                  <span v-html="text">
                     {{ text }}
                     <span v-if="emphesis">
                        <br />
                        {{ emphesis }}
                     </span>
                  </span>
               </span>
               <span v-else-if="type === 'confirm' && showConfirmText"
                  >האם אתה בטוח שברצונך לבצע את הפעולה?</span
               >

               <div style="margin-top: 10px">
                  <div
                     v-if="secondButton && !secondButton.isImg"
                     class="notificationButton notificationConfirmButton2 right"
                     @click="$emit('action')"
                  >
                     <p v-if="!secondButton.isImg">
                        {{ secondButton.data }}
                     </p>
                  </div>
                  <div
                     v-if="thirdButton"
                     class="notificationButton notificationConfirmButton3"
                     @click="confirmNotification({ msg: 'send' })"
                  >
                     אישור ושליחת מכתב
                  </div>
                  <div
                     v-if="type === 'error'"
                     class="notificationButton notificationCancelButton"
                     @click="closeNotification()"
                  >
                     אישור
                  </div>
                  <div
                     v-else-if="type === 'confirm' || type === 'success'"
                     class="notificationButton notificationConfirmButton"
                     :class="{'w-160': customConfirmText}"
                     @click="confirmNotification({ msg: 'confirm' })"
                  >
                     {{ confirmYesText }}
                  </div>
                  <div
                     v-else-if="type != 'confirm' && type != 'yesno'"
                     class="notificationButton notificationConfirmButton"
                     @click="closeNotification()"
                  >
                     אישור
                  </div>
                  <div
                     v-if="type === 'confirm'"
                     class="notificationButton notificationCancelButton right"
                     :class="{'w-160': customConfirmText}"
                     @click="cancel()"
                  >
                     {{ confirmNoText }}
                  </div>
                  <div
                     v-if="type === 'yesno'"
                     class="notificationButton notificationConfirmButton"
                     @click="confirmNotification({ msg: 'yes' })"
                  >
                     כן
                  </div>

                  <div
                     v-if="type === 'yesno'"
                     class="notificationButton notificationCancelButton"
                     @click="confirmNotification({ msg: 'no' })"
                  >
                     לא
                  </div>
               </div>
            </div>
         </div>
         <div
            v-if="secondButton && secondButton.isImg"
            class="secondButtonImage"
            @click="$emit('action')"
         >
            <img :src="secondButton.data" class="printerBtn" />
         </div>
      </template>
   </uiModal>
</template>
<script>
export default {
   props: {
      text: {},
      selection: {},
      type: {},
      emphesis: {},
      activate: { default: false },
      secondButton: { default: false },
      thirdButton: { default: false },
      prop: {},
      cancelMethod: {},
      currMargin: null,
      currOverflow: null,
      showConfirmText: { default: true },
      confirmYesText: { default: 'אישור' },
      confirmNoText: { default: 'ביטול' },
      customConfirmText: { default: false },
   },
   name: 'NotificationsComponent',
   data() {
      return {
         display: false,
      }
   },
   methods: {
      confirmNotification({ msg }) {
         this.$emit(msg)
         this.$parent[this.prop] = false
      },
      cancel() {
         this.closeNotification()
         this.$emit('cancel')
         this.$parent[this.prop] = false
      },
      showNotification() {
         this.display = true
         this.$emit('display', true)
      },
      closeNotification() {
         this.activate = false
         this.display = false
         this.$parent[this.prop] = false
         this.$emit('display', false)
      },
   },
   watch: {
      activate() {
         if (this.activate) {
            this.showNotification()
         } else {
            this.closeNotification()
         }
      },
   },
   created() {
      this.currMargin = document.body.style.margin
      this.currOverflow = document.body.style.overflow
   },
   beforeDestroy() {
      document.body.style.margin = this.currMargin
      document.body.style.overflow = this.currOverflow
   },
}
</script>
<style lang="less" scoped>
@import '../assets/css/style.less';
.header {
   img {
      height: 60px !important;
      max-width: 120px !important;
   }
}

.globalNotifications {
   z-index: 99999999999999;
}

.notificationButton {
   padding: 5px 5px;
   font-size: 20px;
   text-align: center;
   cursor: pointer;
   width: 120px;
   display: block;
   margin: 20px auto 0;
}

.notificationConfirmButton {
   cursor: pointer;
   color: @blue-dark;
   background: @white;
   border: 0.5px solid @blue-dark;
   display: inline-block;
   vertical-align: top;
}
.secondButtonImage {
   position: absolute;
   cursor: pointer;
   max-height: 26px;
   background: #fff;
   left: -50px;
   bottom: -20px;
}
.notificationConfirmButton2 {
   cursor: pointer;
   max-height: 26px;
   color: @orange;
   background: @white;
   border: 0.5px solid #336666;
   display: inline-block;
   margin-left: 20px;
   vertical-align: top;
}
.notificationConfirmButton3 {
   cursor: pointer;
   height: 26px;
   font-size: 16px;
   color: @white;
   background: @orange;
   border: 0.5px solid @orange;
   display: inline-block;
   margin-left: 20px;
   vertical-align: top;
}

.notificationCancelButton {
   color: @red;
   background: @white;
   border: 0.5px solid @red;
   display: inline-block;
   vertical-align: top;
}

.confirmHeaderText,
.yesnoHeaderText {
   font-size: 20px;
}

.body {
   font-size: 20px;
   margin: 20px;
   margin-bottom: 0 !important;
}

.right {
   margin-right: 15px;
}
.printerBtn {
   transition: all 0.3s;
   transform: scale(1);
   cursor: pointer;
   &:hover {
      transition: all 0.3s;
      transform: scale(1.05);
   }
}
.w-160 {
   width: 160px;
}
</style>



// WEBPACK FOOTER //
// src/Notifications/NotificationComponent.vue